import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListChannelComponent } from './list/listchannel.component';
import { FormChannelComponent } from './Form/form.component';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { MainPanelModule } from '../main-panel/main-panel.component';

const routes: Routes = [
  { path: '', redirectTo: 'list', pathMatch: 'full' },
  { path: 'list', component: ListChannelComponent },
  { path: 'form', component: FormChannelComponent },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MainPanelModule,
    RouterModule.forChild(routes),
  ],
  declarations: [ListChannelComponent, FormChannelComponent],
})
export class ChannelModule {}
